import { Admin } from 'react-admin';
import { QueryClient } from 'react-query';
import { AppProvider } from './contexts/AppContext';
import { CustomLayout } from './layouts/CustomLayout';
import authProvider from './providers/authProvider';
import { dataProvider } from './providers/dataProvider';
import { i18nProvider } from './providers/i18nProvider';
import { UserProvider } from './providers/userProvider';
import { Resources } from './resources/Resources';
import PageLogin from './resources/auth/PageLogin';
import {
  customRoutes,
  DashboardWrapper,
  noLayout,
} from './routes/customRoutes';
import { customTheme } from './themes/customTheme';

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1 * 60 * 1000, // 1 minute
      },
    },
  });
  return (
    <AppProvider>
      <UserProvider>
        <Admin
          disableTelemetry
          queryClient={queryClient}
          title={` `}
          loginPage={PageLogin}
          layout={CustomLayout}
          authProvider={authProvider}
          dataProvider={dataProvider}
          i18nProvider={i18nProvider}
          dashboard={DashboardWrapper}
          customRoutes={customRoutes}
          theme={customTheme}
        >
          {permissions => Resources(permissions)}
          {customRoutes()}
          {noLayout()}
        </Admin>
      </UserProvider>
    </AppProvider>
  );
};

export default App;
